<template>
  <div>
    <multiselect v-model="item" track-by="id" placeholder="Type to search" open-direction="bottom" :options="items" :multiple="false" :searchable="true"
      :loading="isLoading" :internal-search="false" :clear-on-select="true" :close-on-select="true" :options-limit="100" :max-height="600"
      :show-no-results="false" :hide-selected="true" @search-change="find" label="text">
      <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
    </multiselect>
  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect
  },
  props: {
    value: {
      type: Object
    },
    endpoint: {
      type: String
    }
  },
  data() {
    return {
      item: null,
      items: [],
      isLoading: false
    };
  },
  watch: {
    item() {
      this.$emit('input', this.item);
    }
  },
  mounted() {
    // Use an empty term to load a complete list
    this.find('');
  },
  methods: {
    async find(term) {
      try {
        this.isLoading = true;
        const { data } = await axios.get(this.endpoint, {
          params: { term },
          validateStatus: status => status === 200,
        });

        this.$assert(data && Array.isArray(data.items) && data.items.length, 'Invalid response');

        const { items } = data;
        this.items = items;
      } catch (err) {
        this.$log.error(err);
        this.items = [];
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/misc/GreenhouseMultiSelect.vue